import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from 'react';
import {
  FaBuilding,
  FaCalendarAlt,
  FaClipboard,
  FaClock,
  FaEdit,
  FaEye,
  FaFileAlt,
  FaFlag,
  FaMinus,
  FaSyncAlt,
  FaTrash,
  FaUser,
  FaCheck,
  FaPlay,
  FaAlignLeft,
  FaPauseCircle,
  FaHourglass,
  FaCalendarDay,
  FaStopCircle,
} from 'react-icons/fa';
import { FiRotateCw } from 'react-icons/fi';
import { useParams, useLocation, useHistory, Link } from 'react-router-dom';

import {
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  IconButton,
  Popover,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
  Tooltip,
  Wrap,
  WrapItem,
  useDisclosure,
  useToast,
  Skeleton,
} from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { format, parseISO } from 'date-fns';
import queryString from 'query-string';
import * as Yup from 'yup';

import { User } from '~/modules/accessControl/@types/user';
import {
  Attendance,
  ActivityProps,
  DevolutionData,
} from '~/modules/activityExecution/@types/activity';
import { Pop as PopInterface } from '~/modules/activityExecution/@types/activity';
import ActivityDevolution from '~/modules/activityExecution/components/ActivityDevolution';
import Pop from '~/modules/activityExecution/components/Pop';
import Planning from '~/modules/activityExecution/pages/Planning';
import BadgeStatusAttendance from '~/modules/dashboard/components/BadgeStatusAttendance';
import BadgeStatusInfo from '~/modules/dashboard/components/BadgeStatusInfo';
import AlertDialog from '~/shared/components/AlertDialog';
import Highlights from '~/shared/components/Highlights';
import InputChakra from '~/shared/components/InputChakra';
import CheckboxInput from '~/shared/components/InputChakra/CheckboxChakra';
import SelectChakra from '~/shared/components/InputChakra/SelectChakra';
import LoadingAbsolute from '~/shared/components/LoadingAbsolute';
import ModalChakra from '~/shared/components/Modal/ChakraUI';
import ModalReplan from '~/shared/components/Modal/ModalReplan';
import SectionHeader from '~/shared/components/SectionHeader';
import Table, { THeadProps } from '~/shared/components/Table';
import api from '~/shared/services/api';
import getFormattedDurationOver24hours from '~/utils/getFormattedDurationOver24hours';
import getOptionsAllowedResponsibles from '~/utils/getOptionsAllowedResponsibles';
import getValidationErrors from '~/utils/getValidationErrors';

interface AttendancesStatus {
  attendances_status_id: number;
  nome: string;
  total: string;
  color: string;
  description: string;
}

interface UserSelect extends User {
  label: string;
  label_resp: string;
  value: number;
}

interface PlanningAttendance extends Attendance {
  attendance_started?: string;
  attendance_finished?: string;
}

interface PlanningActivityProps extends ActivityProps {
  devolutions?: DevolutionData[];
  activity_type_id?: number;
  activity_type?: string;
  activity_type_description?: string;
  allowed_responsibilities: { id: number; name: string }[];
  successors: { id: number; order: number }[];
}

interface PlanningProps {
  planning_employee_demand: PlanningActivityProps[];
  activities_not_in_attendance: PlanningActivityProps[];
  total_activities_expected_duration: TotalActivitiesExpectedDuration;
}

interface TotalActivitiesExpectedDuration {
  preview_duration: string;
  real_duration?: string;
}

interface Params {
  attendanceId?: string;
}

interface DeletePlanning {
  employee_attendance_id: number;
  employee_id: number;
  planning: PlanningActivityProps;
}

interface ReplanData {
  activity_id: string;
  attendance_id: string;
  current_employee: string;
  duration_activities: string;
  employee_attendance_id: string;
  fatal_date: string;
  fatal_hours: string;
  minimum_start: string;
  new_employee: string;
  status_id: string;
}

interface Activity {
  id: number;
  pop: string;
  activity_type_name: string;
  activity_character_name: string;
  activity_type_description: string;
  name: string;
  description: string;
  duration: string;
  duration_min: string;
  order: number;
  demand_id: number;
  type_activity_id: number;
}

interface Devolution {
  responsible_devolution_name: string;
  planning_id_fail: number;
  func_name: string;
  atv_name: string;
  atv_order: number;
  reason_devolution: string;
  created_at: string;
}

const AttendancesPlanning: React.FC = () => {
  const { attendanceId } = useParams<Params>();
  // const location = useLocation();
  const history = useHistory();

  const formRef = useRef<FormHandles>(null);
  const formRefReplan = useRef<FormHandles>(null);
  const deleteRef = useRef(null);
  const addToast = useToast();
  const currentDate = format(new Date(), 'yyyy-MM-dd');
  const [attendance, setAttendance] = useState<PlanningAttendance>(
    {} as PlanningAttendance,
  );
  const [employees, setEmployees] = useState<User[]>([]);
  const [planningEmployeeDemand, setPlanningEmployeeDemand] = useState<
    PlanningActivityProps[]
  >([]);

  const [
    totalActivitiesExpectedDuration,
    setTotalActivitiesExpectedDuration,
  ] = useState<TotalActivitiesExpectedDuration>();

  const [activitiesNotInAttendance, setActivitiesNotInAttendance] = useState<
    PlanningActivityProps[]
  >([]);

  const [modalPopData, setModalPopData] = useState<PopInterface>();

  const [selectedActivity, setSelectedActivity] = useState<ActivityProps>();

  const [selectedDelete, setSelectedDelete] = useState<DeletePlanning>();

  // const [devolution, setDevolution] = useState<Devolution>();

  const [reload, setReload] = useState(0);
  const [reloadAttendance, setReloadAttendance] = useState(0);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [confirmPlanning, setConfirmPlanning] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [loadingDemandInfo, setLoadingDemandInfo] = useState(true);
  const [LoadingDeletePlanning, setLoadingDeletePlanning] = useState(false);

  const {
    isOpen: isOpenReplan,
    onOpen: onOpenReplan,
    onClose: onCloseReplan,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
  } = useDisclosure();
  const {
    isOpen: isOpenDevolution,
    onOpen: onOpenDevolution,
    onClose: onCloseDevolution,
  } = useDisclosure();

  const [returnedActivity, setReturnedActivity] = useState<{
    id: number;
    obs?: string;
  } | null>(null);

  const handleCreatePlanning = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        if (!data.confirm_planning.length) {
          formRef.current?.setErrors({
            confirm_planning: 'Marque a caixa para continuar',
          });
          return;
        }

        const schema = Yup.object().shape({
          planning: Yup.array(
            Yup.object().shape({
              employee_id: Yup.string().required(
                'Selecione um funcionário da lista',
              ),
              duration: Yup.string().required('Defina a duração da atividade'),
            }),
          ).required(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoadingCreate(true);

        const resp = await api.post('plannings', data);

        const { plannings, attendance_reopened } = resp.data;

        setReload((state) => state + 1);

        // Remover as atividades recém-planejadas dentre as não planejadas no estado
        setActivitiesNotInAttendance((state) =>
          state.filter(
            (act) =>
              !plannings.find(
                (plan: any) => act.activity_id === Number(plan.atividade_id),
              ),
          ),
        );

        let msg: string;

        msg = '';

        if (attendance_reopened) {
          msg += 'Atendimento reaberto e ';
          setReloadAttendance((state) => state + 1);
        }

        msg += `${plannings.length} atividade(s) registrada(s)`;

        addToast({
          position: 'top-right',
          isClosable: true,
          title: msg,
          status: 'success',
        });
      } catch (err) {
        // console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          position: 'top-right',
          isClosable: true,
          title: 'Não foi possível planejar a(s) atividade(s)',
          status: 'error',
        });
      } finally {
        setLoadingCreate(false);
      }
    },
    [addToast],
  );

  const tableTitles = useMemo((): THeadProps[] => {
    const previewDuration =
      totalActivitiesExpectedDuration?.preview_duration || 0;

    const realDuration = totalActivitiesExpectedDuration?.real_duration || 0;

    return [
      {
        title: '#',
      },
      {
        title: 'Funcionário',
      },
      {
        title: 'Planejamento Previsto',
        align: 'center',
        badge: {
          title: 'Tempo previsto',
          value: previewDuration,
          flexDir: 'column',
          alignItems: 'center',
        },
      },
      {
        title: 'Início mínimo',
      },
      {
        title: 'Atividade',
      },
      {
        title: 'Data/Hora Fatal',
      },
      {
        title: 'Status',
      },
      {
        title: 'Planejamento Realizado',
        align: 'center',
        badge: {
          title: 'Tempo Realizado',
          value: realDuration,
          flexDir: 'column',
          alignItems: 'center',
        },
      },
      {
        title: 'Ação',
      },
    ];
  }, [totalActivitiesExpectedDuration]);

  const attendancesPlannings = useCallback(() => {
    setLoading(true);
    api
      .get<PlanningProps>(`/attendances/${attendanceId}/plannings`)
      .then((resp) => {
        const {
          planning_employee_demand,
          activities_not_in_attendance,
          total_activities_expected_duration,
        } = resp.data;

        // console.log('teste');

        setPlanningEmployeeDemand(
          planning_employee_demand?.map((planning) => {
            return {
              ...planning,
              formatted_start_date: planning.start_date
                ? format(parseISO(planning.start_date), 'dd/MM/yy')
                : '',
              formatted_end_date: planning.end_date
                ? format(parseISO(planning.end_date), 'dd/MM/yy')
                : '',
              formatted_duration:
                planning.start_date && planning.duration
                  ? format(
                      parseISO(`${planning.start_date} ${planning.duration}`),
                      "HH'h'mm",
                    )
                  : '',
              formatted_minimum_start: planning.minimum_start
                ? format(
                    parseISO(planning.minimum_start),
                    "dd/MM/yyyy 'às' HH'h'mm",
                  )
                : 'NÃO',
              formatted_fatal_date_time:
                planning.fatal_date && planning.fatal_time
                  ? format(
                      parseISO(`${planning.fatal_date} ${planning.fatal_time}`),
                      "dd/MM/yyyy 'às' HH'h'mm",
                    )
                  : 'NÃO',
              formatted_start_and_date_time:
                planning.start_date && planning.start_time
                  ? format(
                      parseISO(`${planning.start_date} ${planning.start_time}`),
                      'HH:mm',
                    )
                  : '',
              formatted_end_date_time:
                planning.end_date && planning.end_time
                  ? format(
                      parseISO(`${planning.end_date} ${planning.end_time}`),
                      'HH:mm',
                    )
                  : '',
              formatted_allocation_activity:
                planning.start_date && planning.allocation_activity
                  ? format(
                      parseISO(
                        `${planning.start_date} ${planning.allocation_activity}`,
                      ),
                      'HH:mm',
                    )
                  : '',
            };
          }),
        );

        setActivitiesNotInAttendance(activities_not_in_attendance);

        /* A duração prevista pode não vir se o atendimento foi recém criada e ainda não tem atividades planejadas,
        por exemplo */
        setTotalActivitiesExpectedDuration({
          preview_duration: total_activities_expected_duration?.preview_duration
            ? getFormattedDurationOver24hours(
                total_activities_expected_duration.preview_duration,
              )
            : '',
          real_duration: total_activities_expected_duration?.real_duration
            ? getFormattedDurationOver24hours(
                total_activities_expected_duration.real_duration,
              )
            : '',
        });
      })

      .finally(() => {
        setLoading(false);
      });
  }, [attendanceId]);

  const demandInfo = useCallback(() => {
    setLoadingDemandInfo(true);
    api
      .get<PlanningAttendance>(`/attendances/${attendanceId}`)
      .then((response) => {
        const { data } = response;

        setAttendance({
          ...data,
          created_at: format(
            parseISO(data.created_at),
            "dd/MM/yyyy 'às' HH'h'mm'min'",
          ),
          attendance_started: data.attendance_started
            ? format(
                parseISO(data.attendance_started),
                "dd/MM/yyyy 'às' HH'h'mm'min'",
              )
            : 'Não iniciado',
          attendance_finished: data.attendance_finished
            ? format(
                parseISO(data.attendance_finished),
                "dd/MM/yyyy 'às' HH'h'mm'min'",
              )
            : '',
        });
      })
      .finally(() => setLoadingDemandInfo(false));
  }, [attendanceId]);

  const handleRemoveActivity = useCallback((activityId: number) => {
    setActivitiesNotInAttendance((state) =>
      state.filter((act) => act.activity_id !== activityId),
    );
  }, []);

  const handleDeletePlanning = useCallback(async (): Promise<void> => {
    setLoadingDeletePlanning(true);

    try {
      const resp = await api.delete(
        `/plannings/${selectedDelete?.employee_attendance_id}`,
        {
          params: {
            employee_id: selectedDelete?.employee_id,
          },
        },
      );

      const { data: finishedAttendance } = resp;

      setPlanningEmployeeDemand((state) =>
        state.filter((planning) => {
          return planning.id !== selectedDelete?.employee_attendance_id;
        }),
      );

      let msg: string;

      msg = 'Registro deletado com sucesso';

      if (finishedAttendance) {
        msg += ' e atendimento finalizado';

        setReloadAttendance((state) => state + 1);
      }

      msg += '!';

      addToast({
        position: 'top-right',
        isClosable: true,
        title: 'Planejamento deletado.',
        description: msg,
        status: 'success',
      });
    } catch (err) {
      // console.log(err);
      addToast({
        position: 'top-right',
        isClosable: true,
        title: 'Não foi possível apagar o planejamento.',
        description: err.response.data?.error || 'Tente novamente, mais tarde',
        status: 'error',
      });
      return;
    }

    try {
      if (!selectedDelete?.planning) return;

      const allPlanningsNotInAttendance = [
        ...activitiesNotInAttendance,
        selectedDelete.planning,
      ];

      // Ordenar as atividades por ordem incluindo a que foi removida do planejamento
      setActivitiesNotInAttendance(
        allPlanningsNotInAttendance.sort(
          (a, b) => a.order_activity - b.order_activity,
        ),
      );
    } finally {
      setLoadingDeletePlanning(false);
      onCloseDelete();
    }
  }, [activitiesNotInAttendance, addToast, onCloseDelete, selectedDelete]);

  /*  const devolutionInfo = useCallback((planId: number) => {
    api
      .get<Devolution>(`/plannings//${planId}`)

      .then((response) => {
        const { data } = response;

        setDevolution({
          atv_name: data.atv_name,
          atv_order: data.atv_order,
          created_at: data.created_at,
          func_name: data.func_name,
          planning_id_fail: data.planning_id_fail,
          reason_devolution: data.reason_devolution,
          responsible_devolution_name: data.responsible_devolution_name,
        });
        setReturnedActivity({ id: planId });
      });
  }, []);
 */
  const handleDevolutionPage = (
    plan_id: number,
    dem_id: number,
    act_id: number,
    aten_id: number,
  ): void => {
    history.push({
      pathname: `/planejamento/${plan_id}/devolucao`,
      search: `?dem_id=${dem_id}&act_id=${act_id}&aten_id=${aten_id}`,
    });
  };

  const handleShowPlan = (date: string, employee_id: number): void => {
    history.push({
      pathname: `/planejamento`,
      search: `?date=${date}&employee=${employee_id}`,
    });
  };

  useEffect(() => {
    api
      .get<User[]>('users/all')
      .then((resp) => {
        const users = resp.data;

        setEmployees(users);
      })
      .catch(() => {
        addToast({
          position: 'top-right',
          isClosable: true,
          title: 'Não foi possível buscar os usuários',
          status: 'error',
        });
      })
      .finally(() => setLoadingUsers(false));
  }, [addToast]);

  useEffect(() => {
    attendancesPlannings();
    // console.log(currentDate);
  }, [attendancesPlannings, reload]);

  useEffect(() => {
    demandInfo();
  }, [demandInfo, reloadAttendance]);

  const getIcon = useCallback((statusId) => {
    switch (statusId) {
      case 15:
        return <FaStopCircle color="blue" size={12} />;
      case 16:
        return <FaCheck color="green" size={12} />;
      case 17:
        return <FaPauseCircle color="orange" size={12} />;

      default:
        return <FaClock size={12} />;
    }
  }, []);

  const getColor = useCallback((statusId) => {
    switch (statusId) {
      case 15:
        return 'blue';
      case 16:
        return 'green';
      case 17:
        return 'orange';

      default:
        return 'gray';
    }
  }, []);

  return (
    <Box pos="relative">
      {/*  {(loading || loadingDemandInfo) && (
        <LoadingAbsolute z_index={1111} min_height={500} />
      )} */}
      <SectionHeader
        title="Planejamento"
        pagename="Planejamento para atendimento"
        goBackPage
      >
        <Flex>
          {/* <Button colorScheme="yellow" variant="outline" mr={[0, 4]}>
            <FaEye /> <Text ml="5px">VER ATENDIMENTO</Text>
          </Button> */}
          <Button variant="outline" colorScheme="cyan" disabled>
            <FaSyncAlt /> <Text marginLeft="5px">DEMANDA RECORRENTE</Text>
          </Button>
        </Flex>
      </SectionHeader>

      <Flex
        width="full"
        // flexDir={['column', 'column', 'column', 'row']}
        wrap="wrap"
        alignItems="start"
      >
        <Box display="inline-block" mb={4}>
          <Text fontSize="2xl" whiteSpace="nowrap">
            {`Atend. ${attendanceId}`}
          </Text>
          {loadingDemandInfo ? (
            <Skeleton width="full" height="24px" />
          ) : (
            <BadgeStatusInfo
              status={attendance.status.name}
              statusColor={attendance.status.color.name}
              variant="outline"
              displayFull
              size="md"
            />
          )}
        </Box>
        <Flex width="full" justifyContent={['start', 'center']}>
          <Highlights
            justify="space-between"
            enableLoading
            isLoading={loadingDemandInfo}
            data={[
              {
                icon: FaClipboard,
                label: 'Demanda:',
                text: attendance?.demand?.name,
                widthSke: '230px',
              },
              {
                icon: FaBuilding,
                label: 'Empresa:',
                text: attendance?.company_client?.name,
                widthSke: '230px',
              },
              /* {
                icon: FaFileAlt,
                label: 'Descrição:',
                text: attendance?.description,
              }, */
              /* {
                icon: FaUser,
                label: 'Solicitante',
                text: attendance?.user?.name,
              }, */
              {
                icon: FaCalendarAlt,
                label: 'Data de solicitação:',
                text: attendance?.created_at,
                widthSke: '230px',
              },
            ]}
            pl={0}
          />
        </Flex>
      </Flex>

      {/* <Flex justifyContent="space-between">
        <Highlights
          enableLoading
          isLoading={loadingDemandInfo}
          data={[
            {
              icon: FaCalendarDay,
              label: 'Iniciado em:',
              text: attendance?.attendance_started,
              widthSke: '230px',
            },
            {
              icon: FaCalendarDay,
              label: 'Finalizado em:',
              text: attendance?.attendance_finished,
              widthSke: '230px',
            },
            {
              icon: FaCalendarDay,
              label: 'Tempo previsto:',
              text: `${totalActivitiesExpectedDuration?.preview_duration}`,
            },
          ]}
        />
      </Flex> */}

      <Flex justifyContent="space-between">
        {/* <Box>
          <Highlights
            enableLoading
            isLoading={loadingDemandInfo}
            data={[
              {
                icon: FaFileAlt,
                label: 'Descrição:',
                text: attendance?.description,
              },
            ]}
          />
        </Box> */}

        <Box>
          {attendance?.competence && (
            <Box>
              <Badge variant="solid" colorScheme="gray" mr="5px">
                Competência:
              </Badge>
              <Badge>{attendance?.competence}</Badge>
            </Box>
          )}
        </Box>
      </Flex>

      {loading &&
        [...Array(2)].map((_, i) => {
          const key = i + 1;

          return (
            <Box
              mt="30px"
              key={key}
              border="1px"
              padding="15px"
              borderColor="#e3e3e3"
              borderRadius="10px"
            >
              <Form onSubmit={() => null}>
                <Tooltip label="Remover" aria-label="Remover" placement="top">
                  <Badge variant="solid" colorScheme="red" userSelect="none">
                    <FaMinus />
                  </Badge>
                </Tooltip>

                <Flex justifyContent="space-between" mb="20px" mt="10px">
                  <Skeleton pl={1} width="300px" height="24px" />

                  <Flex alignItems="center">
                    <Badge>Tipo:</Badge>

                    <Skeleton pl={1} width="215px" height="18px" />
                  </Flex>
                </Flex>

                <Wrap>
                  <WrapItem mt="20px">
                    <Box>
                      <Skeleton width="85px" height="24px" mb={1} />
                      <Skeleton width="300px" height="48px" />
                    </Box>
                  </WrapItem>

                  <WrapItem mt="20px">
                    <Box>
                      <Skeleton width="85px" height="24px" mb={1} />
                      <Skeleton width="300px" height="48px" />
                    </Box>
                  </WrapItem>
                  {/* </Flex> */}

                  {/* <Flex justifyContent="center"> */}
                  <WrapItem mt="20px">
                    <Box>
                      <Skeleton width="85px" height="24px" mb={1} />
                      <Skeleton width="300px" height="48px" />
                    </Box>
                  </WrapItem>

                  <WrapItem mt="20px">
                    <Box>
                      <Skeleton width="85px" height="24px" mb={1} />
                      <Skeleton width="120px" height="48px" />
                    </Box>
                  </WrapItem>
                </Wrap>
              </Form>
            </Box>
          );
        })}

      <Form onSubmit={handleCreatePlanning} ref={formRef}>
        {!loading && !!activitiesNotInAttendance.length && (
          <>
            {activitiesNotInAttendance?.map((activity, idx) => {
              const allowedEmployees = getOptionsAllowedResponsibles(
                activity.allowed_responsibilities,
                employees,
              );

              return (
                <Box
                  mt="30px"
                  key={activity.activity_id}
                  border="1px"
                  padding="15px"
                  borderColor="#e3e3e3"
                  borderRadius="10px"
                >
                  <InputChakra
                    type="hidden"
                    name="attendance_id"
                    value={attendance?.id}
                    isInline
                  />
                  <InputChakra
                    type="hidden"
                    name={`planning[${idx}].activity_id`}
                    value={activity.activity_id}
                    isInline
                  />
                  <Tooltip label="Remover" aria-label="Remover" placement="top">
                    <Badge
                      variant="solid"
                      colorScheme="red"
                      userSelect="none"
                      cursor="pointer"
                      onClick={() => handleRemoveActivity(activity.activity_id)}
                    >
                      <FaMinus />
                    </Badge>
                  </Tooltip>

                  <Flex justifyContent="space-between" mb="20px" mt="10px">
                    <Text color="#707486">{`${activity.order_activity} - ${activity.name}`}</Text>

                    <Box>
                      <Badge>Tipo:</Badge>
                      <Tooltip
                        label={activity.activity_type_description}
                        aria-label={activity.activity_type_description}
                      >
                        <Badge
                          colorScheme="blue"
                          whiteSpace="break-spaces"
                          textAlign="center"
                        >
                          {activity.activity_type}
                        </Badge>
                      </Tooltip>
                    </Box>
                  </Flex>

                  <Wrap>
                    <WrapItem mt="20px">
                      <SelectChakra
                        name={`planning[${idx}].employee_id`}
                        options={allowedEmployees}
                        label="Funcionário"
                        placeholder="Selecione um funcionário"
                      />
                    </WrapItem>
                    <WrapItem mt="20px">
                      <InputChakra
                        type="datetime-local"
                        label="Início Mínimo"
                        name={`planning[${idx}].minimum_start`}
                        width="auto"
                      />
                    </WrapItem>
                    {/* </Flex> */}
                    {/* <Flex justifyContent="center"> */}
                    <WrapItem mt="20px">
                      <InputChakra
                        type="datetime-local"
                        label="Data Fatal"
                        name={`planning[${idx}].fatal_date`}
                        width="auto"
                      />
                    </WrapItem>
                    <WrapItem mt="20px">
                      <InputChakra
                        type="time"
                        label="Duração da ativade"
                        name={`planning[${idx}].duration`}
                        width="auto"
                        defaultValue={format(
                          parseISO(`${currentDate} ${activity.duration}`),
                          'HH:mm',
                        )}
                      />
                    </WrapItem>
                  </Wrap>
                </Box>
              );
            })}
          </>
        )}
        {/* {planningEmployeeDemand.map((planningEmp) => {
          return ( */}
        {(loading || !!planningEmployeeDemand.length) && (
          <Box mt="30px">
            <Table theadData={tableTitles} loading={loading} noOfLines={2}>
              {planningEmployeeDemand?.map((planning) => {
                return (
                  <Box as="tr" key={planning.order_activity}>
                    <Box as="td">
                      <Flex justifyContent="center">
                        {planning.situation_id === 14 ? (
                          <Tooltip aria-label="Replanejar" label="Replanejar">
                            <IconButton
                              aria-label="editar"
                              icon={<FaEdit />}
                              variant="ghost"
                              colorScheme="yellow"
                              onClick={() => {
                                setSelectedActivity({
                                  ...planning,
                                  activity_id: planning.activity_id,
                                  order_activity: planning.order_activity,
                                  employee_id: planning.employee_id,
                                  minimum_start: planning.minimum_start,
                                  fatal_date: planning.fatal_date,
                                  fatal_time: planning.fatal_time,
                                  duration: planning.duration,
                                });

                                onOpenReplan();
                              }}
                            />
                          </Tooltip>
                        ) : (
                          ''
                        )}
                        {planning.overallocation &&
                        planning.situation_id !== 16 ? (
                          <Tooltip
                            aria-label="Superalocação"
                            label="Superalocação"
                          >
                            <Link
                              to={`/superalocacao?func=${planning.employee_id}&data=${planning.start_date}`}
                            >
                              <IconButton
                                icon={<FaHourglass />}
                                variant="ghost"
                                colorScheme="red"
                                aria-label="Superalocação"
                              />
                            </Link>
                          </Tooltip>
                        ) : (
                          ''
                        )}
                      </Flex>
                    </Box>
                    <Box as="td">
                      <Tooltip
                        aria-label="Ver planejamento do funcionário"
                        label="Ver planejamento do funcionário"
                      >
                        <Button
                          variant="ghost"
                          onClick={() =>
                            handleShowPlan(
                              planning.start_date,
                              planning.employee_id,
                            )
                          }
                        >
                          <Text isTruncated maxW={400}>
                            {planning.employee}
                          </Text>
                        </Button>
                      </Tooltip>
                    </Box>
                    {/* <Box as="td">
                      <Flex alignItems="center" justifyContent="center">
                        <Tooltip>
                          <Button variant="ghost" onClick={() => null}>

                            <Text ml="5px">{planning.name}</Text>
                          </Button>
                        </Tooltip>
                      </Flex>
                    </Box> */}
                    <Box as="td">
                      <Flex justifyContent="center">
                        {planning.start_date === planning.end_date ? (
                          <Text color="#787f9a">
                            {format(parseISO(planning.start_date), 'dd/MM/yy')}
                          </Text>
                        ) : (
                          <Text color="#787f9a">
                            {`${format(
                              parseISO(planning.start_date),
                              'dd/MM/yy',
                            )} até ${format(
                              parseISO(planning.end_date),
                              'dd/MM/yy',
                            )}`}
                          </Text>
                        )}
                      </Flex>
                      <Flex justifyContent="center" alignItems="center">
                        <Badge>
                          {format(
                            parseISO(
                              `${planning.start_date} ${planning.start_time}`,
                            ),
                            'HH:mm',
                          )}
                        </Badge>
                        <Text mx={2} color="#787f9a">
                          às
                        </Text>
                        <Badge>
                          {format(
                            parseISO(
                              `${planning.end_date} ${planning.end_time}`,
                            ),
                            'HH:mm',
                          )}
                        </Badge>
                        <Text mx={1} color="#787f9a">
                          |
                        </Text>
                        <Tooltip
                          aria-label="Duração da atividade"
                          label="Duração da atividade"
                        >
                          <Text fontSize="sm" as="b">
                            {planning.duration
                              ? format(
                                  parseISO(
                                    `${currentDate} ${planning.duration}`,
                                  ),
                                  "HH'h'mm",
                                )
                              : ''}
                          </Text>
                        </Tooltip>
                      </Flex>
                    </Box>

                    <Box as="td">
                      <Flex justifyContent="center">
                        <Badge
                          colorScheme={
                            planning.formatted_minimum_start !== 'NÃO'
                              ? 'green'
                              : ''
                          }
                        >
                          {planning.minimum_start
                            ? format(
                                parseISO(planning.minimum_start),
                                "dd/MM/yyyy 'às' HH'h'mm",
                              )
                            : 'NÃO'}
                        </Badge>
                      </Flex>
                    </Box>
                    <Box as="td">
                      <>
                        {!!planning.devolutions?.length && (
                          <Flex justifyContent="end">
                            <Button
                              onClick={() => {
                                setReturnedActivity({
                                  id: planning.id,
                                  obs: planning.observation,
                                });
                              }}
                              size="xs"
                              colorScheme="blackAlpha"
                              rounded="lg"
                              my={2}
                            >
                              <Text>
                                {`Devoluções: ${planning.devolutions?.length}`}
                              </Text>
                            </Button>
                          </Flex>
                        )}

                        <Box>
                          <Button
                            variant="ghost"
                            onClick={() => {
                              setModalPopData({
                                name: `${planning.order_activity} - ${planning.name}`,
                                pop: planning.activity_pop || '',
                                description:
                                  planning.activity_description || '',
                              });
                              // onOpenActivity();
                            }}
                          >
                            <Text isTruncated maxW={300} color="#787f9a">
                              {`${planning.order_activity} - ${planning.name}`}
                            </Text>
                          </Button>
                        </Box>
                      </>
                    </Box>
                    <Box as="td" justifyContent="center">
                      <Flex justifyContent="center">
                        <Badge
                          colorScheme={
                            planning.formatted_fatal_date_time !== 'NÃO'
                              ? 'yellow'
                              : ''
                          }
                        >
                          {planning.fatal_date &&
                            planning.formatted_fatal_date_time}
                        </Badge>
                      </Flex>
                    </Box>
                    <Box as="td">
                      <Flex justifyContent="center">
                        <Tooltip
                          label={planning.situation}
                          aria-label={planning.situation}
                          placement="top"
                        >
                          {/* <Badge
                          display="flex"
                          alignItems="center"
                          height="20px"
                          width="20px"
                          colorScheme={planning.status_id === 16 ? 'green' : ''}
                        > */}
                          <IconButton
                            aria-label="icon"
                            icon={getIcon(planning.situation_id)}
                            variant="ghost"
                            colorScheme={getColor(planning.situation_id)}
                            cursor="unset"
                          />
                          {/* </Badge> */}
                        </Tooltip>
                      </Flex>
                    </Box>
                    <Box as="td">
                      {!!planning.start_real_date &&
                      !!planning.end_real_date &&
                      !!planning.allocation_activity ? (
                        <>
                          <Flex justifyContent="center">
                            <Text mx={2} color="#787f9a">
                              {format(
                                parseISO(planning.start_real_date),
                                'dd/MM/yy',
                              )}
                            </Text>
                            <Text color="#787f9a"> até </Text>
                            <Text mx={1} color="#787f9a">
                              {format(
                                parseISO(planning.end_real_date),
                                'dd/MM/yy',
                              )}
                            </Text>
                          </Flex>
                          <Flex justifyContent="center" alignItems="center">
                            <Badge>
                              {format(
                                parseISO(planning.start_real_date),
                                'HH:mm',
                              )}
                            </Badge>
                            <Text mx={2} color="#787f9a">
                              às
                            </Text>
                            <Badge>
                              {format(
                                parseISO(planning.end_real_date),
                                'HH:mm',
                              )}
                            </Badge>
                            <Text mx={1} color="#787f9a">
                              |
                            </Text>
                            <Tooltip aria-label="Duração" label="Duração">
                              <Text fontSize="sm" as="b">
                                {planning.formatted_allocation_activity ===
                                '00:00'
                                  ? planning.allocation_activity
                                  : planning.formatted_allocation_activity}
                              </Text>
                            </Tooltip>
                          </Flex>
                        </>
                      ) : (
                        ''
                      )}
                    </Box>
                    <Box as="td">
                      <Flex justifyContent="center">
                        {planning.situation_id === 14 ? (
                          <Tooltip
                            label="Apagar"
                            aria-label="Apagar"
                            placement="top"
                          >
                            <IconButton
                              aria-label="Apagar"
                              icon={<FaTrash />}
                              variant="ghost"
                              colorScheme="red"
                              onClick={() => {
                                onOpenDelete();
                                setSelectedDelete({
                                  employee_attendance_id: planning.id,
                                  employee_id: planning.employee_id,
                                  planning,
                                });
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip
                            label="Devolução de atividade"
                            aria-label="Devolução"
                            placement="top"
                          >
                            <IconButton
                              aria-label="Cancelar"
                              icon={<FiRotateCw />}
                              variant="ghost"
                              colorScheme="gray"
                              onClick={() =>
                                handleDevolutionPage(
                                  planning.id,
                                  Number(planning.demand_id),
                                  planning.activity_id,
                                  planning.attendance_id,
                                )
                              }
                            />
                          </Tooltip>
                        )}
                      </Flex>
                    </Box>
                  </Box>
                );
              })}
            </Table>
          </Box>
        )}

        <Flex
          justifyContent="space-between"
          mt="30px"
          display={
            loading || !activitiesNotInAttendance.length ? 'none' : 'flex'
          }
        >
          {/* <Checkbox onChange={() => setConfirmPlanning(!confirmPlanning)}>
                Confirmar Planejamento?
              </Checkbox> */}
          <Box>
            <CheckboxInput
              name="confirm_planning"
              options={[
                {
                  id: '1',
                  label: 'Confirmar planejamento?',
                  value: '1',
                },
              ]}
            />
          </Box>

          <Button
            colorScheme="green"
            variant="solid"
            onClick={() => formRef.current?.submitForm()}
            isLoading={loadingCreate}
          >
            Registrar
          </Button>
        </Flex>
      </Form>

      {selectedActivity && (
        <ModalReplan
          planning={selectedActivity}
          isOpen={isOpenReplan}
          onClose={() => onCloseReplan()}
          updated={() => setReload(reload + 1)}
        />
      )}

      {!!modalPopData && (
        <Pop
          data={modalPopData}
          onClosePop={() => setModalPopData(undefined)}
        />
      )}

      <AlertDialog
        title="Apagar planejamento?"
        description="Deseja apagar o planejamento selecionado?"
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        onSubmit={() => handleDeletePlanning()}
        leastDestructiveRef={deleteRef}
        isLoading={LoadingDeletePlanning}
      />

      {returnedActivity && (
        <ActivityDevolution
          id={returnedActivity.id}
          obs={returnedActivity.obs}
          onCloseDevolution={() => setReturnedActivity(null)}
        />
      )}
    </Box>
  );
};

export default AttendancesPlanning;
